import { JWTAuth } from "../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../lib/js-apiclient/src/AdvancedApiClient";

export class ChannelApiClient extends AdvancedApiClient {

    static entityType = "Channel"

    constructor(token, id) {
        super();

        this.setEntityType(ChannelApiClient.entityType);

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/channel/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/channel")
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}